/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Run_ButtonInputs */



/**
* | output |
* | --- |
* | "Run" |
*
* @param {Spellcheck_Run_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_run_button = /** @type {((inputs?: Spellcheck_Run_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Run_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lancer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Laufen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correre")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Бегать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Correr")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("跑步")
	if (locale === "ja") return /** @type {LocalizedString} */ ("走る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दौड़ना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Correr")
	return /** @type {LocalizedString} */ ("Run")
});